"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Text = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _utils = require("../../utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var getColor = function getColor(color, themeColor) {
  return {
    primary: themeColor.brandPrimary.light,
    'primary-dark': themeColor.brandPrimary.medium,
    secondary: themeColor.brandSecondary.medium,
    text: themeColor.neutral['02'],
    'text-light': themeColor.neutral['03'],
    white: themeColor.neutral['08'],
    warning: themeColor.feedback.alert,
    error: themeColor.feedback.error,
    success: themeColor.feedback.success
  }[color];
};
var Text = exports.Text = _styledComponents["default"].p.withConfig({
  displayName: "Textstyle__Text",
  componentId: "sc-1401i95-0"
})(function (_ref) {
  var theme = _ref.theme,
    align = _ref.align,
    color = _ref.color,
    display = _ref.display,
    margin = _ref.margin,
    variant = _ref.variant;
  return _objectSpread(_objectSpread({
    textAlign: align,
    display: display,
    color: getColor(color, theme.color),
    marginTop: 0,
    marginBottom: !margin && 0
  }, (0, _utils.getTextStyle)({
    theme: theme,
    variant: variant,
    margin: margin
  })), {}, {
    svg: {
      fill: 'currentColor',
      width: '1em',
      height: '1em',
      top: '.125em',
      position: 'relative'
    }
  });
});